export const infoText = [
  'A single dashboard with a summary of your cashflow, wealth and protection',
  'Prepare for emergencies, set savings targets and achieve them with a plan',
  'Simple explanations of financial concepts to help you understand and improve your financial health',
];

export const tabHeaderList = ['Consolidate', 'Plan', 'Learn'];
